import styled from 'styled-components';
import { darken, desaturate } from 'polished';

export const Container = styled.button<{ color: string }>`
  height: 100%;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ color, disabled }) => (disabled ? desaturate(1, color) : color)};
  cursor: pointer;
  transition: 0.2s;

  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};

  &:hover {
    background-color: ${({ color }) => darken(0.1, color)};
  }
`;
